import { BlocklyError } from '../../utils/blockly-error';
import { FixedBlockType } from '../../types/block-type';
import { assertNever } from 'webui/utils/never';
export function createElement(doc, tagName, attributes) {
    const element = doc.createElement(tagName);
    attributes.forEach((attr) => {
        element.setAttribute(attr.name, attr.value);
    });
    return element;
}
export function createStringChild(doc, element, field_value, value) {
    const filed = createElement(doc, 'field', [{ name: 'name', value: field_value }]);
    filed.appendChild(doc.createTextNode(value.toString()));
    element.appendChild(filed);
}
const week_day_index = {
    Mo: 0,
    Tu: 1,
    We: 2,
    Th: 3,
    Fr: 4,
    Sa: 5,
    Su: 6,
};
function createWeekDayChild(doc, element, field_value, value) {
    const field = createElement(doc, 'field', [{ name: 'name', value: field_value }]);
    field.appendChild(doc.createTextNode(value & (1 << week_day_index[field_value]) ? 'TRUE' : 'FALSE'));
    element.appendChild(field);
}
function createWeekDaysChild(doc, element, value) {
    Object.keys(week_day_index).forEach((day) => createWeekDayChild(doc, element, day, value));
}
export function JSONBlock2XML(doc, block) {
    const element = createElement(doc, 'block', [{ name: 'type', value: block.type }]);
    Object.entries(block).forEach(([key, value]) => {
        switch (key) {
            case 'type':
                break;
            case 'weekday_register':
                createWeekDaysChild(doc, element, value);
                break;
            case 'next':
                if (value != null && 'next' in value) {
                    createNextChild(doc, element, value);
                }
                break;
            case 'statement':
            case 'then':
            case 'else':
                if (value != null) {
                    if (block.type === FixedBlockType.if_run) {
                        createBlockChild(doc, element, 'statement', 'statement', value);
                    }
                    else {
                        createBlockChild(doc, element, 'statement', key, value);
                    }
                }
                break;
            case 'comparator':
            case 'right':
            case 'left':
            case 'inp':
                createBlockChild(doc, element, 'value', key, value);
                break;
            default:
                createStringChild(doc, element, key, value);
        }
    });
    return element;
}
export function mainB2X(block) {
    const doc = document.implementation.createDocument('', '', null);
    const main = createElement(doc, 'xml', []);
    if (block) {
        try {
            main.appendChild(resolverB2X(doc, block));
        }
        catch (e) {
            console.error('mainB2X', 'не смог добавить блоки в поле', e);
            return main.outerHTML;
        }
    }
    return main.outerHTML;
}
export function createBlockChild(doc, element, field_tag, field_value, block) {
    const field = createElement(doc, field_tag, [{ name: 'name', value: field_value }]);
    if (block != null) {
        field.appendChild(resolverB2X(doc, block));
    }
    element.appendChild(field);
}
export function createNextChild(doc, element, next_block) {
    const next = createElement(doc, 'next', []);
    next.appendChild(resolverB2X(doc, next_block));
    element.appendChild(next);
}
function doHeatModeForHeatCircuitB2X(doc, block) {
    const type_plus_heat_mode_id = block.type + ':' + block.mode;
    const element = createElement(doc, 'block', [
        { name: 'type', value: type_plus_heat_mode_id },
    ]);
    if (block.next) {
        createNextChild(doc, element, block.next);
    }
    createStringChild(doc, element, 'name', block.name);
    switch (block.for) {
        case 'all':
            createStringChild(doc, element, 'zones', 1);
            break;
        case 'single':
            createStringChild(doc, element, 'zones', block.circuit);
            break;
        default:
            assertNever(block);
    }
    return element;
}
function andOrB2X(doc, block) {
    const el = createElement(doc, 'block', [{ name: 'type', value: block.type }]);
    if (block.clauses == null) {
        return el;
    }
    //добавляем детей
    block.clauses.forEach((claus, index) => createBlockChild(doc, el, 'value', (block.type === 'and' ? 'and_' : 'or_') + (index + 1), claus));
    return el;
}
function numericComparatorB2X(doc, block) {
    const element = createElement(doc, 'block', [{ name: 'type', value: block.type }]);
    createStringChild(doc, element, 'comparator_type', block.comparator_type);
    createStringChild(doc, element, 'right', block.right);
    createBlockChild(doc, element, 'value', 'left', block.left);
    return element;
}
export function resolverB2X(doc, block) {
    const type = block.type;
    switch (type) {
        case FixedBlockType.do_heat_mode_for_heat_circuit:
            return doHeatModeForHeatCircuitB2X(doc, block);
        //logic
        case FixedBlockType.and:
        case FixedBlockType.or:
            return andOrB2X(doc, block);
        case FixedBlockType.numeric_comparator:
            return numericComparatorB2X(doc, block);
        case FixedBlockType.if_then:
        case FixedBlockType.if_then_else:
        case FixedBlockType.linear:
        case FixedBlockType.if_run:
        case FixedBlockType.schedule_run:
        case FixedBlockType.loop:
        case FixedBlockType.not:
        case FixedBlockType.sensor_comparator:
        case FixedBlockType.do_notification:
        case FixedBlockType.do_output_action:
        case FixedBlockType.do_pump:
        case FixedBlockType.do_relay:
        case FixedBlockType.set_guard:
        case FixedBlockType.do_buzzer:
        case FixedBlockType.do_tap:
        case FixedBlockType.do_temperature_in_circuit:
        case FixedBlockType.pause:
        case FixedBlockType.do_scenario:
        case FixedBlockType.do_return:
        case FixedBlockType.do_break:
        case FixedBlockType.do_continue:
        case FixedBlockType.analog_input:
        case FixedBlockType.radio_input:
        case FixedBlockType.temperature_input:
        case FixedBlockType.state_heat_mode_for_heat_circuit:
        case FixedBlockType.analog_input_state:
        case FixedBlockType.analog_temperature_sensor_state:
        case FixedBlockType.guard_state:
        case FixedBlockType.pump_state:
        case FixedBlockType.radio_sensor_state:
        case FixedBlockType.radio_sensor_433_state:
        case FixedBlockType.relay_state:
        case FixedBlockType.buzzer_state:
        case FixedBlockType.tap_state:
        case FixedBlockType.wired_temperature_sensor_state:
        case FixedBlockType.boiler_adapter:
        case FixedBlockType.time_comparator:
        case FixedBlockType.weekdays_input:
            return JSONBlock2XML(doc, block);
        default:
            throw new BlocklyError('resolverB2X', `нет преобразователя для ${type}`);
    }
}
